export const buttonText = Object.freeze({
    MORE: 'Read more',
    LESS: 'Read less',
});
